import React from 'react';
import {useParams} from 'react-router-dom';
import {Grid, Typography, CardContent, Chip,  CardHeader, Card} from '@mui/material';
import QueryProcessor from '../components/QueryProcessor';
import useMempoolTx from '../queries/useMempoolTx';
import {TabbedMainCard} from '../components/MainCard';
import {JSONTextField} from '../components/JSONTextField';
import {RichList, RichListItem} from '../components/RichList';
import AccessTimeIcon from '@mui/icons-material/AccessTime';
import {InputItem, OutputsItem} from '../components/TransactionItem'

function useTxWithPrecheck(txid?: string) {
    if (!txid || !txid.startsWith('0x') || txid.length !== 66) {
        throw new Error('Illegal txid.');
    }
    return useMempoolTx(txid);
}

function MempoolTxOverview({d}: { d: any }) {
    return (
        <RichList sx={{width: 1, mt: -2}}>
            <RichListItem
                title={'Transaction Hash'}
                help={
                    'A TxHash or transaction hash is a unique 66-character identifier\
                     that is generated whenever a transaction is executed.'
                }
            >
                <Typography variant={'body2'}>0x{d.txid}</Typography>
            </RichListItem>

            <RichListItem title={'Status'} help={'The status of the transaction.'}>
                <Chip icon={<AccessTimeIcon/>} label={'Pending'} color={'warning'} size={'small'}/>
            </RichListItem>

            {/*<RichListItem*/}
            {/*    title={'Block Height'}*/}
            {/*    help={*/}
            {/*        'Number of the block in which the transaction is recorded. Block confirmations\*/}
            {/*         indicate how many blocks have been added since the transaction was mined.'*/}
            {/*    }*/}
            {/*>*/}
            {/*    <Typography component={'span'} variant={'body1'}>*/}
            {/*        <SmartLink to={`/block/0x${d.blockhash}`}>{d.blockheight}</SmartLink>*/}
            {/*    </Typography>*/}

            {/*    {latestBlock.height != -1 && (*/}
            {/*        <Typography component={'span'} variant={'body2'} sx={{pr: 1}}>*/}
            {/*            {` (${latestBlock.height - d.blockheight} confirmations)`}*/}
            {/*        </Typography>*/}
            {/*    )}*/}
            {/*</RichListItem>*/}

            {/*<RichListItem title={'Block Hash'}*/}
            {/*              help={'The hash of the block header of the block recording this transaction.'}>*/}
            {/*    <Typography variant={'body2'}>*/}
            {/*        <SmartLink to={`/block/0x${d.blockhash}`}>0x{d.blockhash}</SmartLink>*/}
            {/*    </Typography>*/}
            {/*</RichListItem>*/}

            {/*<RichListItem title={'Timestamp'} help={'The date and time at which a transaction is mined.'}>*/}
            {/*    <Stack direction={'row'} sx={{alignItems: 'center'}} spacing={0.5}>*/}
            {/*        <AccessTimeIcon sx={{fontSize: 14, color: 'text.secondary'}}/>*/}
            {/*        <Typography>{`${formatDurationAbbr(dts, ts)} ago (${formatRFC7231(dts).substring(5)})`}</Typography>*/}
            {/*    </Stack>*/}
            {/*</RichListItem>*/}

            <RichListItem title={'Type'} help={'The type of the transaction (coinbase or transfer).'}>
                {d.txtype}
            </RichListItem>

            <RichListItem title={'From'} help={'The sending party of the transaction.'}>
                {d.txtype === 'coinbase' ? (
                    <Typography variant={'body2'} fontFamily={'monospace'}>
                        0x0 (Null Address)
                    </Typography>
                ) : (
                    <Typography variant={'body2'} fontFamily={'monospace'}>
                        {`${d.vin.length} Inputs`}
                    </Typography>
                    /*        <Stack direction={'column'} sx={{ alignItems: 'left' }} spacing={0.5}>
                              {d.vinoutpointring.map((outpointring: any, idx: number) => (
                                <Typography key={idx} variant={'body2'} fontFamily={'monospace'}>
                                  <SmartLink to={`/address/0xabe1${fingerprint}`}>0x{addressPrefixFromFingerprint(fingerprint)}...</SmartLink>
                                </Typography>
                              ))}
                            </Stack>*/
                )}
            </RichListItem>

            <RichListItem title={'To'} help={'The receiving party of the transaction.'}>
                <Typography variant={'body2'} fontFamily={'monospace'}>
                    {`${d.vout.length} Outputs`}
                </Typography>
                {/*<Stack direction={'column'} sx={{ alignItems: 'left' }} spacing={0.5}>*/}
                {/*  {VoutFingerprints.map((fingerprint: any, idx: number) => (*/}
                {/*    <Typography key={idx} variant={'body2'} fontFamily={'monospace'}>*/}
                {/*      <SmartLink to={`/address/0xabe1${fingerprint}`}>0x{addressPrefixFromFingerprint(fingerprint)}...</SmartLink>*/}
                {/*    </Typography>*/}
                {/*  ))}*/}
                {/*</Stack>*/}
            </RichListItem>

            <RichListItem
                title={'Value'}
                help={
                    'For coinbase transaction, the value is the total reward of the containing block. For transfer transaction, the value is the transaction fee.'
                }
            >
                {d.fee} ABEL
            </RichListItem>
        </RichList>
    );
}

export function ViewMempoolTx() {
    let {txid} = useParams();
    if (txid && !txid.startsWith('0x')) {
        txid = '0x' + txid;
    }

    return (
        <QueryProcessor
            query={useTxWithPrecheck(txid)}
            dataValidator={(data: any) => data.type === 'tx'}
            renderer={(data: any) => (
                <Grid container spacing={2}>
                    <Grid item xs={12}>
                        <Typography component={'span'} variant={'h2'}>
                            Transaction Details
                        </Typography>
                    </Grid>
                    <Grid item xs={12}>
                        <TabbedMainCard labels={['Overview', 'Raw Data']}>
                            <CardContent>
                                <MempoolTxOverview d={data.payload}/>
                            </CardContent>
                            <CardContent>
                                <JSONTextField value={data}/>
                            </CardContent>
                        </TabbedMainCard>
                    </Grid>
                    <Grid item xs={6}>
                        <Card sx={{mt: 2,minHeight:400}}>
                            <CardHeader
                                title={<Typography variant={'h5'} textAlign={'center'}>{`Inputs`}</Typography>}
                                sx={{p: 0}}
                            />
                            <CardContent>
                                {data.payload.vin.map((input: any, i: any) => (
                                    <InputItem key={`${txid}_input_${i}`} ringid={input.ringid}
                                               outpoints={input.outpoints}
                                               serialnumber={input.serialnumber}
                                               sx={{my:2}}
                                    />
                                ))}
                            </CardContent>
                        </Card>
                    </Grid>
                    <Grid item xs={6}>
                        <Card sx={{mt: 2, minHeight:400}}>
                            <CardHeader
                                title={<Typography variant={'h5'} textAlign={'center'}>{`Outputs`}</Typography>}
                                sx={{p: 0}}
                            />
                            <CardContent>
                                <OutputsItem outputs={data.payload.vout}
                                             sx={{my:2}}
                                />
                            </CardContent>
                        </Card>
                    </Grid>
                </Grid>
            )}
        />
    );
}

export default ViewMempoolTx;
